module.exports = "/assets/59edef4e4f82095b0f2db787d200807f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/N8.png
// module id = 1639
// module chunks = 0